import { useQuery } from '@tanstack/react-query';
import { cms } from 'admin/resources';
import { cmsKeys } from 'admin/queries/queryKeys';
import { EMBEDDING_JOB_POLL_MS } from 'common/utils/cms/vector-search';
import type { EmbeddingConfigurationResponse } from 'types/cms';

interface GetEmbeddingConfigurationInput {
	collectionId: string;
	pollWhilePending?: boolean;
}

export const getEmbeddingConfigurationQueryFn = async ({
	collectionId,
}: Pick<GetEmbeddingConfigurationInput, 'collectionId'>): Promise<EmbeddingConfigurationResponse> => {
	const response = await cms.get.embeddingConfiguration
		.params({ collectionId })
		.send<ApiV2Response<EmbeddingConfigurationResponse>>();
	if (!response.body) {
		throw new Error('Empty embedding configuration response');
	}
	return response.body;
};

export const useEmbeddingConfiguration = ({
	collectionId,
	pollWhilePending = false,
}: GetEmbeddingConfigurationInput) => {
	return useQuery({
		queryKey: cmsKeys.embeddingConfiguration(collectionId),
		queryFn: () => getEmbeddingConfigurationQueryFn({ collectionId }),
		enabled: Boolean(collectionId),
		refetchInterval: pollWhilePending
			? query => {
					const jobs = query.state.data?.jobs;
					return jobs?.waiting || jobs?.inProgress ? EMBEDDING_JOB_POLL_MS : false;
				}
			: false,
	});
};
